
  import { defineComponent, ref, onMounted, onBeforeUnmount, watch, computed } from 'vue';
  import { debounce } from 'lodash';
  import { t } from '@/ui/i18n/i18n';
  import autosize from 'autosize';

  export default defineComponent({
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    emits: ['update-response'],
    setup(props, { emit }) {
      const text = ref(props.item.response ?? '');
      const textarea = ref<HTMLTextAreaElement | undefined>();

      const debounceUpdate = debounce(value => emit('update-response', props.item.uuid, value), 10);

      watch(text, debounceUpdate);

      watch(() => props.item.response, newResponse => {
        text.value = newResponse ?? '';
      });

      onMounted(() => {
        if (textarea.value) {
          autosize(textarea.value);
        }
      });

      onBeforeUnmount(() => {
        if (textarea.value) {
          autosize.destroy(textarea.value);
        }

        debounceUpdate?.cancel();
      });

      const isReadOnly = computed(() => props.item?.prefillReadOnly === true);

      return {
        isReadOnly,
        placeholder: t('Enter text') as string,
        textarea,
        text,
      };
    },
  });
